
import { useMemo } from 'react';
import { useIOSSafeArea } from './useIOSSafeArea';
import { usePlatformDetection } from '@/utils/platform-utils';

interface SafeAreaPadding {
  paddingTop: string;
  paddingBottom: string;
  paddingLeft: string;
  paddingRight: string;
  containerClasses: string;
  headerClasses: string;
  bottomNavClasses: string;
}

export const useSafeAreaPadding = (): SafeAreaPadding => {
  const { isIOS, platformType } = usePlatformDetection();
  const { safeAreaInsets } = useIOSSafeArea();

  return useMemo(() => {
    if (isIOS && platformType === 'ios') {
      // iOS: Use custom padding values instead of native CSS env()
      console.log('iOS detected: Using custom safe area padding');
      return {
        paddingTop: '44px', // Status bar height
        paddingBottom: '34px', // Home indicator height
        paddingLeft: '0px',
        paddingRight: '0px',
        containerClasses: 'ios-native-safe-container',
        headerClasses: 'ios-native-safe-header',
        bottomNavClasses: 'ios-native-safe-bottom-nav'
      };
    } else if (platformType === 'android') {
      // Android: Minimal padding, status bar handled by system
      console.log('Android detected: Using minimal custom padding');
      return {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '0px',
        paddingRight: '0px',
        containerClasses: 'android-safe-container',
        headerClasses: 'android-safe-header',
        bottomNavClasses: 'android-safe-bottom-nav'
      };
    } else {
      // Web: Comfortable padding for browser environment
      console.log('Web detected: Using comfortable custom padding');
      return {
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '0px',
        paddingRight: '0px',
        containerClasses: 'web-safe-container',
        headerClasses: 'web-safe-header',
        bottomNavClasses: 'web-safe-bottom-nav'
      };
    }
  }, [isIOS, platformType, safeAreaInsets]);
};
